import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectors } from "reducers";
import {
  resupplyEmailToPatient,
  resetPasswordEmail,
  sendAppDownloadEmail,
  sendtextConsentEmailToPatient,
  welcomeEmailToPatient,
  sendRemoteSetupEmailToPatient
} from "actions/patient";
import MdKeyboardArrowRight from "react-icons/lib/md/keyboard-arrow-right";
import { MenuItem } from "components/ui/menu";
import PreviewEmail from "./preview-email";

const PatientEmailMenu = ({
  dispatch,
  email_templates,
  openModal,
  closeModal,
  patientEmail,
  patientId,
  disabled,
  patientStageId
}) => {
  return (
  <MenuItem
    disabled={disabled}
    sublist={[
      {
        label: "Reorder Supplies",
        patientStages: [1],
        order: 1,
        onClick: () => dispatch(resupplyEmailToPatient({ patientId }))
      },
      {
        label: "Request Text Consent",
        patientStages: [1, 2, 4],
        order: 2,
        onClick: () =>
          dispatch(
            sendtextConsentEmailToPatient({
              patientId
            })
          )
      },
      {
        label: "App Download Instructions",
        patientStages: [1, 2, 4],
        order: 3,
        onClick: () =>
          dispatch(
            sendAppDownloadEmail({
              patientId
            })
          )
      },
      {
        label: "Reset Password",
        patientStages: [1, 2, 4],
        order: 4,
        onClick: () => {
          dispatch(resetPasswordEmail(patientEmail));
        }
      },
      {
        label: "Welcome to the Resupply Program",
        patientStages: [1],
        order: 5,
        onClick: () => {
          dispatch(welcomeEmailToPatient({ patientId }));
        }
      },
      {
        label: "Welcome to Your Remote Set Up",
        patientStages: [2, 4],
        order: 6,
        onClick: () =>
          dispatch(
            sendRemoteSetupEmailToPatient({
              patientId
            })
          )
      },
      ...email_templates
        .map(({ id, template_name, patient_type_id }, idx) => ({
          label: template_name,
          patientStages: [patient_type_id],
          order: idx + 6,
          onClick: () => {
            openModal(
              <PreviewEmail
                template_id={id}
                patientId={patientId}
                closeSelf={closeModal}
              />
            );
          }
        }))
    ]?.filter(x => x.patientStages.includes(patientStageId))?.sort((a, b) => a.order - b.order)}
  >
    Send Email
    <span className="menu-icon">
      <MdKeyboardArrowRight />
    </span>
  </MenuItem>
)};

PatientEmailMenu.propTypes = {
  dispatch: PropTypes.func.isRequired,
  patientId: PropTypes.string.isRequired,
  email_templates: PropTypes.arrayOf(PropTypes.object).isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  patientEmail: PropTypes.string.isRequired,
  patientStageId: PropTypes.number.isRequired
};

export default connect(state => ({
  email_templates: selectors.getPatientEmailTemplates(state)
}))(PatientEmailMenu);
